import { required } from 'vuelidate/lib/validators'
import { slugValidator, slugAsyncValidator, validationErrorMessages } from '@/utils/validations/validations'
import guidesSlugsQuery from '@/services/gql/types/Guides/queries/guidesSlugs.gql'

export default ({ id, ctx, isNew }) => {
  const isUnique = async (value) => {
    return await slugAsyncValidator(value, id, guidesSlugsQuery, ctx, 'guides')
      .then(res => res)
      .catch(err => console.log(err))
  }
  return {
    name: {
      required: {
        validator: required,
        message: validationErrorMessages.required
      }
    },
    slug: (() => {
      if (isNew) { return false }
      return {
        required: { validator: required, message: validationErrorMessages.required },
        generalValidation: { validator: slugValidator, message: validationErrorMessages.slugGeneralMsg },
        isUnique: { validator: isUnique, message: validationErrorMessages.unique }
      }
    })(),
    description: {
      required: {
        validator: required,
        message: validationErrorMessages.required
      }
    },
    shortDescription: {
      required: {
        validator: required,
        message: validationErrorMessages.required
      }
    }
  }
}
